import React from "react";

export const Martini = ({ className }) => {
  return (
    <svg
      className={`martini ${className}`}
      fill="none"
      height="16"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="g" opacity="0.5">
        <path
          className="path"
          d="M5.33398 14.6667H10.6673M8.00065 7.33333V14.6667M8.00065 7.33333L12.6673 2H3.33398L8.00065 7.33333Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.33333"
        />
      </g>
    </svg>
  );
};